module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/424371873bc8df88d6a305d8727157ab.svg";